interface Opportunity {
  id: string;
  name: string;
  description: string;
}

interface OpportunityCardProps {
  opportunity: Opportunity;
  onChoose?: (opportunity: Opportunity) => void;
  fullWidth?: boolean;
}

const OpportunityCard = ({
  opportunity,
  onChoose,
  fullWidth = false,
}: OpportunityCardProps) => {
  if (!opportunity) return null;

  return (
    <div
      className={
        fullWidth
          ? "w-full"
          : "min-w-[300px] max-w-[320px] w-[78vw] sm:w-[320px] select-none flex-shrink-0"
      }
    >
      <div className="relative border border-border rounded-lg p-5 h-full overflow-visible flex flex-col transition-all duration-200 hover:bg-partner-hover hover:shadow-md">
        {/* Title */}
        <div className="mb-3">
          <h3 className="text-lg font-semibold leading-tight text-primary">
            {opportunity.name}
          </h3>
        </div>

        {/* Description */}
        <p
          className="text-sm text-muted-foreground mb-4 leading-relaxed line-clamp-5 flex-grow"
          style={{ minHeight: "5.5rem" }}
        >
          {opportunity.description}
        </p>

        {/* Choose Button */}
        <div className="flex gap-3 mt-auto">
          <button
            type="button"
            onClick={() => onChoose?.(opportunity)}
            className="inline-flex items-center justify-center w-full px-5 py-2 rounded-full bg-primary hover:opacity-90 text-primary-foreground text-sm font-medium shadow-sm transition-all"
          >
            Choose This Opportunity
          </button>
        </div>
      </div>
    </div>
  );
};

export default OpportunityCard;
